// @flow
function getMaxLength (values: Array<any>, key?: string): number {
  const arrOfLengths = values
    .map(v => {
      if (typeof v === 'object' && key && v[key]) {
        return String(v[key]).length || 0
      }
      if (typeof v === 'string') return v.length
      return 0
    })
    .sort()
  return Math.max(...arrOfLengths)
}

export { getMaxLength }



// WEBPACK FOOTER //
// ./src/shared/helpers/get-text-max-length.js